import { ElementType } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ArrowBack, Settings } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AdminHeader: ElementType = () => {
    const navigate = useNavigate();

    const handleBackNavigation = () => {
        // Check if there's a previous page in history
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            // Fallback to home if no previous page
            navigate('/');
        }
    };

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 3
        }}>
            <Settings sx={{
                fontSize: '2.6rem',
                color: 'primary.main'
            }} />
            <Box sx={{ flexGrow: 1 }}>
                <Typography
                    variant="h6"
                    color="primary"
                    sx={{
                        fontWeight: 400,
                        fontSize: '1.5rem',
                        padding: '4px 0',
                    }}>
                    Administration
                </Typography>
            </Box>

            <Tooltip title="Back">
                <IconButton
                    onClick={handleBackNavigation}
                    sx={{
                        color: 'primary.light',
                        backgroundColor: 'lightGray',
                        flexShrink: 0,
                        '&:hover': {
                            color: 'white',
                            backgroundColor: 'primary.light',
                        }
                    }}
                >
                    <ArrowBack />
                </IconButton>
            </Tooltip>
        </Box>
    )
}

export default AdminHeader;
